export default "__VITE_ASSET__DvFpQ4YB__"